import { Button, Grid, Paper, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { CommissionDto } from '../../services/dtos/commission.dto';
import DateCard from './date-card';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import GroupsIcon from '@mui/icons-material/Groups';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

/**
 * Commission format paper
 * @param props
 * @constructor
 */
export default function CardCommission(
    props: Readonly<{
        commission: CommissionDto;
        handleShowListMembers: (commission: CommissionDto) => void;
        handleShowMeetings: (commission: CommissionDto) => void;
    }>
) {
    // la card contenant les données de la commission
    return (
        <Paper sx={{ padding: '5px' }}>
            <Grid container rowSpacing={0}>
                <Grid item xs={12}>
                    {/*title*/}
                    <Typography variant={'h3'} sx={{ textAlign: 'center', marginTop: '5px' }}>
                        {props.commission.title}
                    </Typography>
                </Grid>
                {/*Affichage des date*/}
                <Grid
                    item
                    xs={5}
                    sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
                >
                    <Typography variant={'h5'} sx={{ textAlign: 'center' }}>
                        Du
                    </Typography>
                    <DateCard date={props.commission.startDate} />
                </Grid>
                <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <ArrowForwardIcon sx={{ fontSize: '100px', color: '#e0e0e0' }} />
                </Grid>
                <Grid
                    item
                    xs={5}
                    sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}
                >
                    <Typography variant={'h5'} sx={{ textAlign: 'center' }}>
                        Au
                    </Typography>
                    <DateCard date={props.commission.endDate} />
                </Grid>
                {/*Prochaine réunion*/}
                <Grid
                    item
                    xs={12}
                    sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}
                >
                    <Typography variant={'h5'} sx={{ textAlign: 'center' }}>
                        Prochaine réunion :
                    </Typography>
                    <Typography variant={'h6'} sx={{ textAlign: 'center' }}>
                        {props.commission.nextDate ? props.commission.nextDate : 'Pas de prochaine réunion programmée'}
                    </Typography>
                </Grid>
                <Grid item xs={1}>
                    <Tooltip title={'Afficher la liste des membres'}>
                        <GroupsIcon
                            sx={{ fontSize: '30px' }}
                            data-testid={'show-list'}
                            onClick={() => props.handleShowListMembers(props.commission)}
                        />
                    </Tooltip>
                </Grid>
                <Grid item xs={8}></Grid>
                <Grid item xs={3}>
                    <Button
                        data-testid="meetingFromCommission"
                        variant={'text'}
                        sx={{ textAlign: 'center', width: '100%', textDecoration: 'none' }}
                        onClick={() => props.handleShowMeetings(props.commission)}
                    >
                        <CalendarMonthIcon />
                        <Typography variant="body1" sx={{ color: '#3766A5' }} className="url-text">
                            Voir les réunions
                        </Typography>
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
}
